import { Action, Reducer } from 'redux';
import {
  SubModelState,
  SubModelTypes,
  SubModelActionTypes
} from './subModelTypes';
import {
  haskeyReducer,
  resetIsolatedReducer,
  updateGetIsolated,
  updateSaveIsolated
} from '@/main/services/reducerUtils';

export const INITIAL_STATE: SubModelState = {
  subModels: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const subModelReducer: Reducer<SubModelState> = (
  state: SubModelState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as SubModelActionTypes;
  switch (actionTypes.type) {
    case SubModelTypes.GET_SUBMODELS:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        subModels: { ...state.subModels, isLoading: true }
      };
    case SubModelTypes.SAVE_SUBMODELS:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

      return {
        ...state,
        subModels: {
          ...state.subModels,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case SubModelTypes.RESET_REDUCER_SUBMODELS:
      const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

      return {
        ...state,
        subModels: INITIAL_STATE.subModels
      };
    default:
      return state;
  }
};

export default subModelReducer;

